import React, { createContext, useContext, useState, useCallback } from "react";

// Preferencias de UI compartidas entre el menú de perfil (header) y TicketsManager.
// Antes vivían como estado local en TicketsManager; se elevan a contexto para que
// los toggles del menú desplegable las gobiernen sin perder la persistencia ni la
// reactividad de la lista de tickets. Mismas keys de localStorage de siempre.
const SHOW_GROUPS_KEY = "showGroups";
const HIDE_CHANNELS_KEY = "waia_hide_channels";

const UiPrefsContext = createContext({
  showGroups: false,
  hideChannels: true,
  toggleShowGroups: () => {},
  toggleHideChannels: () => {},
});

export const UiPrefsProvider = ({ children }) => {
  const [showGroups, setShowGroups] = useState(
    () => localStorage.getItem(SHOW_GROUPS_KEY) === "true"
  );
  const [hideChannels, setHideChannels] = useState(
    () => localStorage.getItem(HIDE_CHANNELS_KEY) !== "false"
  );

  const toggleShowGroups = useCallback(() => {
    setShowGroups((prev) => {
      const next = !prev;
      localStorage.setItem(SHOW_GROUPS_KEY, next ? "true" : "false");
      return next;
    });
  }, []);

  const toggleHideChannels = useCallback(() => {
    setHideChannels((prev) => {
      const next = !prev;
      localStorage.setItem(HIDE_CHANNELS_KEY, next ? "true" : "false");
      return next;
    });
  }, []);

  return (
    <UiPrefsContext.Provider
      value={{ showGroups, hideChannels, toggleShowGroups, toggleHideChannels }}
    >
      {children}
    </UiPrefsContext.Provider>
  );
};

export const useUiPrefs = () => useContext(UiPrefsContext);
